<template>
  <div class="q-mt-md">
    <div class="text-h6 q-mb-sm">Источники данных</div>

    <q-banner v-if="documents.length === 0 && transfers.length === 0" dense rounded class="bg-grey-2">
      Источники данных для этого отчета не указаны.
    </q-banner>

    <q-table
      v-if="documents.length"
      v-accessible-scroll-region="{ label: 'Документы — источники отчета', selector: '.q-table__middle' }"
      title="Документы"
      flat
      dense
      bordered
      row-key="id"
      :rows="normalizedDocuments"
      :columns="documentColumns"
      :pagination="{ rowsPerPage: 20 }"
    >
      <template v-slot:body-cell-source="props">
        <q-td :props="props">
          <q-btn
            v-if="documentRoute(props.row)"
            flat
            dense
            color="primary"
            icon="open_in_new"
            label="Открыть"
            @click="$router.push(documentRoute(props.row))"
          />
          <span v-else>—</span>
        </q-td>
      </template>
    </q-table>

    <q-table
      v-if="transfers.length"
      v-accessible-scroll-region="{ label: 'Проводки — источники отчета', selector: '.q-table__middle' }"
      class="q-mt-md"
      title="Проводки"
      flat
      dense
      bordered
      row-key="id"
      :rows="normalizedTransfers"
      :columns="transferColumns"
      :pagination="{ rowsPerPage: 20 }"
    />
  </div>
</template>

<script>
import { formatMoney } from '../utils/reportFormatters'

const documentColumns = [
  { name: 'type', label: 'Тип', field: (row) => row.type || row.document_type || 'Документ', align: 'left' },
  { name: 'number', label: 'Номер', field: (row) => row.number || row.in_org_number || row.name || '—', align: 'left' },
  { name: 'date', label: 'Дата', field: (row) => row.date || row.date_display || '—', align: 'left' },
  { name: 'amount', label: 'Сумма', field: (row) => row.amount ?? row.summ_total ?? row.summ, format: (value) => formatMoney(value), align: 'right' },
  { name: 'counterparty', label: 'Контрагент', field: (row) => row.counterparty || row.contr_name || '—', align: 'left' },
  { name: 'source', label: 'Ссылка', field: 'source', align: 'left' }
]

const transferColumns = [
  { name: 'date', label: 'Дата', field: (row) => row.date || row.date_display || '—', align: 'left' },
  { name: 'bill_from', label: 'Кредит', field: (row) => row.bill_from || row.credit || '—', align: 'left' },
  { name: 'bill_to', label: 'Дебет', field: (row) => row.bill_to || row.debet || '—', align: 'left' },
  { name: 'summ', label: 'Сумма', field: (row) => row.summ ?? row.amount, format: (value) => formatMoney(value), align: 'right' },
  { name: 'document', label: 'Документ', field: (row) => row.document || row.document_name || '—', align: 'left' }
]

export default {
  name: 'ReportSources',
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    transfers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      documentColumns,
      transferColumns
    }
  },
  computed: {
    normalizedDocuments() {
      return this.documents.map((item) => {
        if (item && typeof item === 'object') {
          return item
        }
        return {
          id: item,
          document_id: item,
          type: 'Документ',
          number: item
        }
      })
    },
    normalizedTransfers() {
      return this.transfers.map((item) => {
        if (item && typeof item === 'object') {
          return item
        }
        return {
          id: item,
          document: `Проводка #${item}`
        }
      })
    }
  },
  methods: {
    documentRoute(row) {
      const id = row.document_id || row.id
      const type = row.document_type || row.type
      if (!id) {
        return null
      }
      if (type === 'upd' || type === 'sale' || type === 'purchase') {
        return { name: 'document_info_upd', params: { id, history_id: 'last' } }
      }
      if (type === 'payment') {
        return { name: 'document_info_payment', params: { id, history_id: 'last' } }
      }
      if (type === 'factura_avance') {
        return { name: 'document_info_factura_avance', params: { id, history_id: 'last' } }
      }
      return null
    }
  }
}
</script>
